import React from 'react';
import { Route, Switch } from 'react-router-dom';
import 'whatwg-fetch';
import StatChartCommercial from './statChartCommercial';
import StatChartSupport from './support/statChartSupport';
import CommercialReport from './support/CommercialReport';
import { Grid } from '@material-ui/core';
import StatsMenu from './components/StatsMenu/StatsMenu';

const AppStats = ({ match, history, openToast }) => {
  return (
    <Grid style={{ marginTop: 30 }} container justifyContent='center'>
      <Grid item xs={11}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={2}>
            <StatsMenu />
          </Grid>

          <Grid item xs={12} lg={10}>
            <Switch>
              <Route
                exact
                path={`${match.url}`}
                render={() => <StatChartCommercial openToast={openToast} history={history} />}
              />

              <Route
                exact
                path={`${match.url}/support`}
                render={() => <StatChartSupport openToast={openToast} history={history} />}
              />

              <Route exact path={`${match.url}/reports`} render={() => <CommercialReport />} />
            </Switch>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AppStats;
